import React, { Component } from 'react';
export default class Footer extends Component {
  
  render() {
    let resumeData = this.props.resumeData;
    const currentDate = new Date().getFullYear();
    return (
      <footer>
      <div className="row">
        <div className="twelve columns">
          <ul className="social-links">
            {
              resumeData.socialLinks && resumeData.socialLinks.map((item)=>{
                return(
                  <li key={item.name}>
                    <a href={item.url} target="_blank" rel="noreferrer">
                    <i className={item.className} />
                    </a>
                  </li>
                )
              })
            }
          </ul>
          <h6 style={{ color: "#000"}}>© johncletusakpan {currentDate} ALL RIGHTS RESERVED </h6>
        </div>
        <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open" /></a></div>
      </div>
    </footer>
    );
  }
}
